<template>
  <div :class="'note '+noteClass+' '+noteType" ref="root">
    <div class="noteimg" ref="noteImg">
      <div class="lines-container" ref="linesContainer">
        <div v-bind:key="line.id" v-for="line in lines" class="line-container">
          <div class="line"></div>
        </div>
        <div class="line" ref="line" style="opacity:0;"></div>
      </div>
      <img class="hane-small" src="../../assets/Main/SubSection/hane_small.png">
      <img class="stamp" src="../../assets/Main/SubSection/stamp.png">

      <div class="note-contents" v-if="noteType=='player'">
        <Player/>
      </div>
      <div class="note-contents" v-else-if="noteType=='direction'">
        <Direction/>
      </div>
      <div class="note-contents" v-else-if="noteType=='artists'">
        <Artists/>
      </div>
    </div>
    <!-- <img class="noteimg" ref="noteimg" src="../../assets/Main/SubSection/note.png"> -->
  </div>
</template>

<script>
  import Player from "../Parts/Player";
  import Direction from "../Parts/Direction";
  import Artists from "../Parts/Artists";

  export default {
    name: "Note",
    components: {
      Player,
      Direction,
      Artists
    },
    data() {
      return {
        noteClass: "invisible",
        isGoingToVisible: 0,
        isGoingToInvisible: 0,
        lines: [],
        disableHide: false
      };
    },
    props: ["noteType"],
    methods: {
      showCallback() {
        if (window.innerWidth <= 768) {
          this.disableHide = true;
        } else {
          this.disableHide = false;
        }
        this.isGoingToVisible++;
        // 消えかけのときは遅延なしで再表示
        if (this.isGoingToInvisible != 0) {
          this.noteClass = "visible";
        }
        setTimeout(() => {
          // 遅延で表示
          if (this.isGoingToInvisible == 0) {
            this.noteClass = "visible";
          }
          this.isGoingToVisible--;
        }, 700);
      },
      hideCallback() {
        if (this.disableHide) {
          return;
        }
        this.isGoingToInvisible++;
        this.noteClass = "invisible";
        setTimeout(() => {
          // 再表示しようとしていなければ位置を右側にリセット
          if (this.isGoingToVisible == 0) {
          }
          this.isGoingToInvisible--;
        }, 700);
      },
      onDisplayed() {
        const $ = require("jquery");

        const onResize = () => {
          this.$refs.linesContainer.style.width =
            $(this.$refs.noteImg).width() + "px";
          let lines = [];
          for (
            let i = 0;
            i <
            Math.round(
              $(this.$refs.noteImg).height() / $(this.$refs.line).outerHeight()
            ) -
            1;
            i++
          ) {
            lines.push({id: i});
          }
          this.lines = lines;
        };
        window.addEventListener("resize", () => {
          onResize();
        });
        onResize();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .note-contents {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .note {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    filter: drop-shadow(1px 1px 10px rgba(0, 0, 0, 0.5));
    &.direction {
      height: 100%;
      width: 100%;
    }
    &.artists {
      height: 100%;
      width: 100%;
    }
  }

  .noteimg {
    position: relative;
    background-color: #f8f3d9;
    width: 100%;
    height: 100%;
    padding: 1.5em;
    display: block;
  }

  @media screen and (max-width: 768px) {
    .hane-small {
      position: absolute;
      transform: scale(0.7, 0.7);
      right: -30px;
      top: -30px;
    }
    .stamp {
      position: absolute;
      transform: scale(0.7, 0.7);
      right: 10px;
      bottom: 10px;
    }
  }

  @media screen and (min-width: 769px) {
    .hane-small {
      position: absolute;
      transform: scale(0.7, 0.7);
      right: -40px;
      top: -40px;
    }
    .stamp {
      position: absolute;
      transform: scale(0.7, 0.7);
      right: 10px;
      bottom: 10px;
    }
  }

  .lines-container {
    position: absolute;
    box-sizing: border-box;
    width: 100%;
  }

  .line {
    height: 1.5em;
    width: 100%;
    border: none;
    border-bottom: 1px #d4ccb3 solid;
  }

  .invisible {
    visibility: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/Parts/Note.vue